import type { StateStorage } from 'zustand/middleware';

import { getStoredUser } from '@shared/auth/auth-route';

function userScopedKey(name: string): string {
  const userId = getStoredUser()?.id;
  return `${name}:${userId ?? 'anon'}`;
}

/**
 * localStorage under the persisted store's name suffixed with the logged-in user
 * id (`<name>:<userId>`, read synchronously from the `auth-user` entry), so a
 * different login on a shared browser reads a different bucket even without a
 * logout in between (DEV-3506).
 */
export const userScopedLocalStorage: StateStorage = {
  getItem: (name) => localStorage.getItem(userScopedKey(name)),
  setItem: (name, value) => {
    localStorage.setItem(userScopedKey(name), value);
  },
  removeItem: (name) => {
    localStorage.removeItem(userScopedKey(name));
  },
};
